import { render } from "./BusinessHome.vue?vue&type=template&id=32d1427a&scoped=true"
import script from "./BusinessHome.vue?vue&type=script&lang=js"
export * from "./BusinessHome.vue?vue&type=script&lang=js"

import "./BusinessHome.vue?vue&type=style&index=0&id=32d1427a&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d1427a"]])

export default __exports__